// import {getContactsWithoutFeedback, saveNotificationToken} from '@/services/apis/dashboard';
// import socket from '@/services/socket';
// import {useModel} from '@umijs/max';
// import {notification} from 'antd';
import { getBrowserUniqueId } from '@/services/ant-design-pro';
import socket from '@/services/ant-design-pro/socket';
import React, {useEffect, useRef, useState} from 'react';


const GlobalComp: React.FC = () => {

  useEffect(() => {



    const token = localStorage.getItem('token');
    socket.emit('authentication', {
      userToken: token,
      uniqueId: getBrowserUniqueId(),
      deviceName: `sample Name`,
    //   deviceName: `${sample}, ${osName}`,
    });

    // socket.on('connect', async () => {
    //   setSocketConnected(true);
    // });

    // socket.on('disconnect', () => {
    //   setSocketConnected(false);
    // });
  }, []);


  // @ts-ignore
  return (
    <>
      {/* <audio ref={audioPlayer} src={NotificationSound}/> */}

    
     
    </>
  );
};

export default GlobalComp;
